import { useState } from "react"
import ErrorMessage from "@/v2-ui/ErrorMessage"
import Dialog from "@/v2-ui/dialog"
import Button, { TooltipButton } from "@/v2-backoffice-client/components/button"
import { useUserAddMfaPhoneMutation } from "@/v2-backoffice-client/user/mfa/user.mfa.addPhone.mutation"
import UserMfaPhoneForm from "@/v2-backoffice-client/user/mfa/UserMfaPhoneForm"

export type UserMfaAddPhoneProps = {
  userId: number
  onCompleted?(): void
}

// Registers a new mobile phone method for the user (e.g. after the bad one is
// removed, give them a working number so they can pass MFA).
function UserMfaAddPhone(props: UserMfaAddPhoneProps) {
  const { userId, onCompleted } = props

  const [open, setOpen] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("")

  const [addPhone, { loading, error }] = useUserAddMfaPhoneMutation({
    onCompleted() {
      setOpen(false)
      onCompleted?.()
    },
  })

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="sm"
        content="Register a new phone number that receives this user's MFA codes."
        onClick={() => {
          setPhoneNumber("")
          setOpen(true)
        }}
        iconSrc="plus"
      >
        Add phone
      </TooltipButton>

      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content align="top">
          <Dialog.Header>
            <Dialog.Title>Add phone number</Dialog.Title>
          </Dialog.Header>

          <ErrorMessage className="my-4 text-center" error={error} />

          <UserMfaPhoneForm
            formId="user-mfa-add-phone-form"
            value={phoneNumber}
            onValueChange={setPhoneNumber}
            onSubmit={() => {
              addPhone({ variables: { id: userId, phoneNumber } })
            }}
          />

          <Dialog.Footer>
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                setOpen(false)
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              isLoading={loading}
              form="user-mfa-add-phone-form"
            >
              Add
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog>
    </>
  )
}

export default UserMfaAddPhone
